import React, { FC, useCallback, useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

import {
  getPackageDataFromCms,
  REDIRECT_URL,
} from './logic';

import PackageContent
  from '../../fe_common/client/components/package/PackageMarketingServiceTypeInfoDialog/PackageContent';
import { Container } from '../../fe_common/client/components/utility/Container';
import CalloutMessage from '../../fe_common/client/components/common/CalloutMessage';

import './index.css';

const PackageView: FC = () => {

  const [servicePackage, setServicePackage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect((): void => {

    async function getData() {

      try {

        const data = await getPackageDataFromCms();

        setServicePackage(data);
        setLoading(false);

      } catch (e) {

        console.error(e);
        setLoading(false);
        setServicePackage(null);

      }

    }

    getData();

  }, []);

  const onBookClick = useCallback(() => {
    window.top.location.href = REDIRECT_URL;
  }, []);

  return (
    <div className="App">
      <Container>
        {!loading && !servicePackage && (
          <CalloutMessage
            message="Sorry, we could not load the requested information"
            type="error"
          />
        )}
        {loading && (
          <Skeleton variant="rect" height={window.innerHeight} />
        )}
        {!!servicePackage && (
          <PackageContent showChatLink={false} service={servicePackage} onBookPackageClick={onBookClick} />
        )}
      </Container>
    </div>
  );

};

export default PackageView;
